<script setup>
import { onMounted, onUnmounted } from 'vue'
import Sidebar from '@/Shared/Sidebar/SidebarBrandV2'
const props = defineProps({
  brandInfo: Object,
  news: Array,
})
onMounted(() => {})
onUnmounted(() => {})
</script>

<template>
  <div v-if="news.length" class="my-10 sm:my-24 md:my-32">
    <div class="contentsContainer">
      <Sidebar :news-list="props.news" />
    </div>
  </div>
</template>

